import { Component, OnInit, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";

import { ObjectTypesService } from "../../services/forms/object-types.service";
import { FieldFormService } from "../../services/forms/field-form.service";

@Component({
  selector: "app-modal-addfield",
  templateUrl: "./modal-addfield.component.html",
  styleUrls: ["./modal-addfield.component.css"]
})
export class ModalAddfieldComponent implements OnInit {
  fieldTypes: any;
  fieldType: any;
  fieldName: any;
  fieldRequired: any;
  formId: any;
  fieldOptions: string;
  fieldSelected: boolean = true;

  constructor(
    protected objectTypesService: ObjectTypesService,
    protected fieldFormService: FieldFormService,
    private dialogRef: MatDialogRef<ModalAddfieldComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.formId = data.formId;

    this.objectTypesService.getObjectTypes().subscribe((data: {}) => {
      this.fieldTypes = data;
    });
  }

  public createFieldForm() {
    const fieldFormDetails = {
      formulario_id: this.formId,
      tipo_objeto_id: this.fieldType,
      formulario_campo_nombre: this.fieldName,
      formulario_campo_requerido: this.fieldRequired
      
    };

    this.fieldFormService
      .createFieldForm(fieldFormDetails)
      .subscribe((data: {}) => {
        if (data["tipo_objeto_id"] == 2) {
          this.createOptionsField(data["formulario_campo_id"]);
        }
        this.dialogRef.close({ data });
      });   
  }

  fieldSelect(){
console.log("selected");
  }

createOptionsField(campo_id){
var options = this.fieldOptions.split(",");
options.forEach((element, index)=> {
  const option = {
        formulario_campo_id: campo_id,
  	  	formulario_campo_opcion_valor: element,
  	  	formulario_campo_opcion_orden: index
  }
  this.fieldFormService.createOption(option).subscribe((data: []) => {
  });
});
}

  public closeMe() {
    this.dialogRef.close();
  }

  ngOnInit() {}
}
